/* eslint-disable jsx-a11y/alt-text */
import { FC, useCallback, useEffect, useMemo, useState } from "react";
import Typhography from "../../../shared/Typhography/Typhography";
import { IEndpointsResponse } from "../../../typings/endpoints";
import CustomButton from "../../../shared/CustomButton/CustomButton";
import { Box, Progress } from "@chakra-ui/react";
import style from "./RegistrationStepper.module.scss";
import CustomTextInput from "../../../shared/CustomInput/CustomTextInput";
import { useSimpleForm } from "../../../hooks/useSimpleForm";
import PhoneInput from "react-phone-input-2";

import dayjs from "dayjs";
import CustomSelectInput from "../../../shared/CustomSelectInput/CustomSelectInput";
import { UploadSimpleIcon } from "@phosphor-icons/react";
import { useDropzone } from "react-dropzone";
import { useEndpoints } from "../../../hooks/useEndpoints";
import CustomPasswordInput from "../../../shared/CustomPasswordInput/CustomPasswordInput";
import { PasswordStrengthMeter } from "../../ui/password-input";
import classNames from "classnames";
import { useToastAlert } from "../../../hooks/useToastAlert/useToastAlert";
const MAX_SIZE = 24 * 1024 * 1024; // 24 MB in byte

// function getDaysInMonth(year: number, month: number): number {
//   // month in dayjs: 0 (Gennaio) → 11 (Dicembre)
//   return dayjs(`${year}-${String(month + 1).padStart(2, "0")}`).daysInMonth();
// }

const DateOfBirthSelector: FC<{
  year: number | null;
  month: number | null;
  handleChange: (key: any, value: any) => void;
  day: number | null;
}> = ({ year: anno, month: mese, day: giorno, handleChange }) => {
  const currentYear = dayjs().year();

  const [giorniPossibili, setGiorniPossibili] = useState<number[]>([]);
  const setGiorno = (value: any) => {
    handleChange("day", value);
  };
  const setMese = (value: any) => {
    handleChange("month", value);
  };
  const setAnno = (value: any) => {
    handleChange("year", value);
  };
  const anni = Array.from({ length: 120 }, (_, i) => currentYear - i);
  const mesi = [
    "Gennaio",
    "Febbraio",
    "Marzo",
    "Aprile",
    "Maggio",
    "Giugno",
    "Luglio",
    "Agosto",
    "Settembre",
    "Ottobre",
    "Novembre",
    "Dicembre",
  ];

  useEffect(() => {
    const giorni = dayjs(
      `${anno ?? currentYear}-${(mese ?? 0) + 1}-01`
    ).daysInMonth();
    setGiorniPossibili(Array.from({ length: giorni }, (_, i) => i + 1));
    if (giorno !== null && giorno > giorni) {
      setGiorno(null);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [anno, mese]);

  return (
    <div className={style.birthDateContainer}>
      <CustomSelectInput
        containerClassName={style.test}
        placeholder="Giorno"
        label="Giorno"
        options={giorniPossibili.map((g) => ({
          label: g,
          value: g,
        }))}
        value={giorno}
        onChange={setGiorno}
      />

      <CustomSelectInput
        containerClassName={style.test}
        placeholder="Mese"
        label="Mese"
        options={mesi.map((mesi, i) => ({
          label: mesi,
          value: i,
        }))}
        value={mese}
        onChange={setMese}
      />

      <CustomSelectInput
        containerClassName={style.test}
        placeholder="Anno"
        label="Anno"
        options={anni.map((anno) => ({
          label: anno,
          value: anno,
        }))}
        value={anno}
        onChange={setAnno}
      />

      {/* <button onClick={handleSubmit}>Conferma</button> */}
    </div>
  );
};

export default DateOfBirthSelector;

export const RegistrationStepper: FC<{
  data: IEndpointsResponse["verifyToken"];
  token: string;
}> = ({ data, token }) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { confirmToken, patchImageUser } = useEndpoints();
  const [status, setStatus] = useState<"registered" | "error">();
  const toastAlert = useToastAlert();
  const [isLoading, setIsLoading] = useState(false);
  const [step, setStep] = useState<1 | 2 | 3 | 4 | 5>();
  const { form, handleChange, handleEventInputChange2 } = useSimpleForm<{
    firstName: string;
    lastName: string;
    password: string;
    confirmPassword: string;
    phoneNumber: string;
    year: null | number;
    month: null | number;
    day: null | number;
    image: null | { file: File; url: string };
  }>({
    firstName: "",
    lastName: "",
    password: "",
    confirmPassword: "",
    phoneNumber: "",
    year: null,
    month: null,
    day: null,
    image: null,
  });
  const onDrop = useCallback((acceptedFiles: File[]) => {
    if (acceptedFiles.length) {
      if (form.image) URL.revokeObjectURL(form.image.url);

      const file = acceptedFiles[0];
      const url = URL.createObjectURL(file);
      handleChange("image", { file, url });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const { getRootProps, getInputProps, open } = useDropzone({
    onDrop,
    accept: {
      "image/*": [],
    },
    maxFiles: 1,
    maxSize: MAX_SIZE,
  });

  const isDisableNextButton =
    (step === 1 && !form.firstName.trim() && !form.lastName.trim()) ||
    (step === 3 &&
      (form.day === null || form.month === null || form.year === null)) ||
    (step === 4 &&
      (!form.password ||
        !form.confirmPassword ||
        form.password !== form.confirmPassword));

  const securityPassword = useMemo(() => {
    const conditions = [
      /\d/.test(form.password),
      // eslint-disable-next-line
      /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(form.password),
      form.password.length >= 10,
    ];
    const trueConditions = conditions.filter(Boolean).length;
    return {
      number: trueConditions,
    };
  }, [form.password]);
  const onSave = async () => {
    setIsLoading(true);
    try {
      const { day, month, year, confirmPassword, image, ...otherKeys } = form;
      const birthdayDate = dayjs(new Date(year!, month! - 1, day!))
        .toDate()
        .toISOString();
      const body = {
        ...otherKeys,
        birthdayDate,
        token,
      };
      const formData = new FormData();
      for (const key of Object.keys(body)) {
        formData.append(key, body[key as keyof typeof body]);
      }
      image && formData.append("image", image.file);
      await confirmToken(formData);
      setStatus("registered");
      toastAlert({
        message: "success",
        type: "success",
      });
    } catch (error) {
      toastAlert({
        message: "error",
        type: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const confirmedToken = () => {
    return (
      <>
        <Typhography size="bold-24" className="mb-3">
          Utenza Confermata
        </Typhography>
        <Typhography size="bold-12" className="mb-3">
          Puoi chiudere questa schermata
        </Typhography>
      </>
    );
  };
  const renderWelcome = () => {
    return (
      <>
        <Typhography size="bold-24" className="mb-2">
          Benvenuto
        </Typhography>
        <Typhography className="mb-3">
          Hai ricevuto un invito da <b>{data?.directorName}</b>.
        </Typhography>
        <Typhography className="mb-4">
          Per usufruire dei servizi di <b>Leopart</b> è necessaria una breve
          registrazione
        </Typhography>
        <CustomButton
          onClick={() => {
            setStep(1);
          }}
        >
          Continua
        </CustomButton>
      </>
    );
  };

  const renderRegistered = () => {
    return (
      <>
        <Typhography size="bold-24" className="mb-3">
          Utenza Creata
        </Typhography>
        <Typhography size="bold-12" className="mb-3">
          Ti diamo il benvenuto al mondo di Leopart Move
        </Typhography>
      </>
    );
  };

  if (status === "registered") return renderRegistered();
  if (data.confirmed) return confirmedToken();
  if (step === undefined) return renderWelcome();

  const renderFirstStep = () => {
    return (
      <Box
        data-state="open"
        _open={{
          animationName: "fade-in",
          animationDuration: "200ms",
        }}
      >
        <CustomTextInput
          label="Nome"
          className="mb-3"
          value={form.firstName}
          onChange={handleEventInputChange2("firstName")}
        />
        <CustomTextInput
          label="Cognome"
          value={form.lastName}
          onChange={handleEventInputChange2("lastName")}
        />
      </Box>
    );
  };

  const renderSecondStep = () => {
    return (
      <Box
        data-state="open"
        _open={{
          animationName: "fade-in",
          animationDuration: "200ms",
        }}
      >
        <Typhography size="bold-14" className="label-input">
          Numero di telefono
        </Typhography>
        <PhoneInput
          placeholder="Inserisci numero di telefono"
          inputClass="w-100"
          country={"it"}
          value={form.phoneNumber}
          onChange={(phoneNumber) => {
            handleChange("phoneNumber", phoneNumber);
          }}
        />
      </Box>
    );
  };

  const renderThirdStep = () => {
    return (
      <Box
        data-state="open"
        _open={{
          animationName: "fade-in",
          animationDuration: "200ms",
        }}
      >
        <DateOfBirthSelector
          day={form.day}
          year={form.year}
          month={form.month}
          handleChange={handleChange}
        />
      </Box>
    );
  };

  const renderFourtyStep = () => {
    return (
      <Box
        data-state="open"
        _open={{
          animationName: "fade-in",
          animationDuration: "200ms",
        }}
      >
        <div className="d-flex flex-column gap-2">
          <Typhography size="bold-20" className="mb-3">
            Carica un’immagine di profilo
          </Typhography>
          <div className="d-flex gap-2">
            <input {...getInputProps()} />
            {!form.image ? (
              <div className={style.dropZoneContainer} {...getRootProps()}>
                <UploadSimpleIcon className={style.uploadIcon} />
              </div>
            ) : (
              <div className={style.dropZoneContainer2}>
                <img src={form.image.url} className={style.logoImage} />
              </div>
            )}
            <div className="d-flex flex-column gap-1">
              <CustomButton onClick={open} color="outline">
                Carica immagine
              </CustomButton>
              {!form.image ? (
                <Typhography size="regular-12">
                  ( Formato .png, .jpg e .jpeg 24mb max )
                </Typhography>
              ) : (
                <CustomButton
                  color="outline"
                  onClick={() => {
                    handleChange("image", null);
                  }}
                >
                  Rimuovi
                </CustomButton>
              )}
            </div>
          </div>
        </div>
      </Box>
    );
  };

  const renderPasswordStep = () => {
    return (
      <Box
        data-state="open"
        _open={{
          animationName: "fade-in",
          animationDuration: "200ms",
        }}
      >
        <div className="d-flex flex-column gap-2">
          <CustomPasswordInput
            label="Password"
            value={form.password}
            onChange={handleEventInputChange2("password")}
          />

          <PasswordStrengthMeter value={securityPassword.number || 1} max={3} />
        </div>
        <CustomPasswordInput
          label="Conferma Password"
          value={form.confirmPassword}
          onChange={handleEventInputChange2("confirmPassword")}
        />
      </Box>
    );
  };

  return (
    <div
      className={classNames("d-flex flex-column gap-2", style.containerForm)}
    >
      <div className="d-flex align-items-center gap-2 mb-3">
        <Progress.Root value={(100 / 5) * step} className="flex-1">
          <Progress.Track className={style.progressTrackContainer}>
            <Progress.Range className={style.progressRangeContainer} />
          </Progress.Track>
        </Progress.Root>
        <div className="d-flex justify-content-end" style={{ minWidth: 40 }}>
          <Typhography className={style.counterLabel}>{step} di 5</Typhography>
        </div>
      </div>
      {step === 1 && renderFirstStep()}
      {step === 2 && renderSecondStep()}
      {step === 3 && renderThirdStep()}
      {step === 4 && renderPasswordStep()}
      {step === 5 && renderFourtyStep()}
      <div className="d-flex gap-3 mt-4">
        {step && step > 1 && (
          <CustomButton
            color="outline"
            className="flex-1"
            onClick={() => {
              setStep((prev) => {
                if (prev === 2) return 1;
                if (prev === 3) return 2;
                if (prev === 4) return 3;
                if (prev === 5) return 4;
                return prev;
              });
            }}
          >
            Indietro
          </CustomButton>
        )}
        <CustomButton
          isLoading={isLoading}
          disabled={isDisableNextButton}
          className="flex-1"
          onClick={() => {
            if (step < 5) {
              setStep((prev) => {
                if (prev === 1) return 2;
                if (prev === 2) return 3;
                if (prev === 3) return 4;
                if (prev === 4) return 5;
                return prev;
              });
            } else {
              onSave();
            }
          }}
        >
          {step === 5 ? "Salva" : "Avanti"}
        </CustomButton>
      </div>
    </div>
  );
};
